import React, { ReactElement } from 'react';
import {
    StyledConnectionIssues,
    StyledSpan,
    StyledIcon,
} from './connection-issues.styled';

export function ConnectionIssues(): ReactElement {
    return (
        <StyledConnectionIssues>
            <StyledIcon type="disconnected" color="white" size={24} />
            <StyledSpan>
                Can’t send or receive messages. Check your connection or try
                again later.
            </StyledSpan>
        </StyledConnectionIssues>
    );
}
